import React, { useState, useEffect } from "react";
import { InputAdornment } from "@mui/material";
import TextField from "@mui/material/TextField";
import Chip from "@mui/material/Chip";
import "../Activities/Styles/ActivityForm.css";

import AddCircleSharpIcon from "@mui/icons-material/AddCircleSharp";
import RemoveCircleSharpIcon from "@mui/icons-material/RemoveCircleSharp";
import Styles from "../../../../Slices/Mof/Styles.json";
import { useGlobalContext } from "../../../../../context";
import DeleteSharpIcon from '@mui/icons-material/DeleteSharp';
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DesktopDatePicker } from "@mui/x-date-pickers/DesktopDatePicker";
// import Input from "@mui/material/Input";
import OutlinedInput from "@mui/material/OutlinedInput";
import axios from "axios";
import ApiSettings from "../../.././../../Settings/ApiSettings.json";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import InputLabel from "@mui/material/InputLabel";

import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import Button from "@mui/material/Button";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";

const Alert = React.forwardRef(function Alert(props, ref) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
  });
  
  const ITEM_HEIGHT = 48;
  const ITEM_PADDING_TOP = 8;
  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
        width: 250,
      },
    },
  };

export default function UpdateOtherBusinessForm(props) {
    const [loading, setLoading] = useState(false);
    const [IpAddress, setIpAddree] = useState("");
    const [otherBusinessFormList, setOtherBusinessFormList] = useState([]);

    const [snackBar, setsnackBar] = useState({
        open: false,
        vertical: "bottom",
        horizontal: "center",
        message: "",
        severity: "",
      });
      const { vertical, horizontal, open } = snackBar;

        //handle clode snackbar
  const handleClose = () => {
    setsnackBar({ ...snackBar, open: false });
  };
  const {
    // loading,
    otherBusinessesList,
    fetchData,
  } = useGlobalContext();

  const [OtherBusinessFormListForUpdate,setOtherBusinessFormListForUpdate]=useState({
    id:props?.object?.id,
    type_id:props?.object?.other_busniess?.id,
    number:props?.object?.form_number,
    date:new Date(props?.object?.form_date),
    issuer:props?.object?.issuer,
    amount:props?.object?.amount,
    currency:props?.object?.currency,
    note:props?.object?.note
  });


  const sentUpdateData=async()=>{
     let data=null;
     setLoading(true)
     try{
        data=await axios({
            method:'put',
            url:ApiSettings.apiUrl+'/other_businesses_form/update',
            data:OtherBusinessFormListForUpdate,
            headers:{
                'Content-Type':'application/json',
                Accept:'application/json',
            }
        })

        if(data){
            if(data.data.status==200){
                props.advanceSearch()
                props.setshowBoxOfEditForm(false)
                setsnackBar({
                    ...snackBar,
                    open: true,
                    severity: "success",
                    message: data.data.message,
                  });
            }else{
                setsnackBar({
                    ...snackBar,
                    open: true,
                    severity: "warning",
                    message: data.data.message,
                  });
            }
            setLoading(false)
        }else{
             setLoading(false)
        }
     }
     catch(err){
        setsnackBar({
            ...snackBar,
            open: true,
            severity: "error",
            message: err.message,
          });
        setLoading(false)

     }
  }


  return (
    <div>
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        flexFlow: "row wrap",
        width: "100%",
      }}
    >
      <div
        style={{
          display: "flex",
          width: "100%",
          backgroundColor: "#5f7b8a",
          color: "#FFFFFF",
          paddingTop: 10,
          paddingBottom: 10,
          borderTopLeftRadius: 10,
          borderTopRightRadius: 10,
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <h2>تعديل المقتبس / التصريح</h2>
      </div>
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          flexFlow: "row wrap",
          width: "98%",
          minWidth: 200,
          border: "1px solid",
          borderColor: "#5f7b8a",
          borderRadius: 10,
          margin: 10,
          paddingBottom: 10,
        }}
      >

        <div
        style={{
            display: "flex",
            flexDirection: "row",
            flexFlow: "row wrap",
            width: "100%",
            minWidth: 200,
            // border: "1px solid",
            borderColor: "#5f7b8a",
            borderRadius: 10,
            margin: 10,
            paddingBottom: 10,
        }}
        >
        
        <div
            style={{
            display: "flex",
            // width: "20%",
            flex: 1,
            minWidth: 200,
            marginTop: 10,
            paddingLeft: 10,
            paddingTop: 10,
            paddingRight: 10,
            justifyContent: "center",
            alignItems: "center",
            }}
        >
            <FormControl fullWidth>
            <InputLabel id="career-simple-select-label">
                نوع المقتبس / التصريحة
            </InputLabel>
            <Select
                labelId="career-simple-select-label"
                id="career-simple-select"
                value={OtherBusinessFormListForUpdate.type_id}
                label="نوع المقتبس / التصريحة"
                onChange={(e) => {
                    setOtherBusinessFormListForUpdate({
                        ...OtherBusinessFormListForUpdate,
                        type_id:e.target.value,
                    })
                // const updatedData = {
                //     ...data,
                //     otherBusinessId: e.target.value,
                // };
                // handleSetOtherBusinessFormList(updatedData);
                }}
            >
                {otherBusinessesList?.map((otherBusiness) => {
                return (
                    <MenuItem
                    value={otherBusiness.id}
                    key={otherBusiness.id + "_type"}
                    >
                    {otherBusiness.type}
                    </MenuItem>
                );
                })}
            </Select>
            </FormControl>

            <Typography className="fontForError"></Typography>
        </div>
        <div
            style={{
            display: "flex",
            width: "33%",
            // flex: 1,
            minWidth: 200,
            marginTop: 10,
            paddingTop: 10,
            paddingLeft: 10,
            paddingRight: 10,
            justifyContent: "center",
            alignItems: "center",
            }}
        >
            <FormControl fullWidth>
            <TextField
                label="الرقم"
                variant="outlined"
                value={OtherBusinessFormListForUpdate.number}
                onChange={(e) => {
                    setOtherBusinessFormListForUpdate({
                        ...OtherBusinessFormListForUpdate,
                        number:e.target.value,
                    })
                }}
            />
            </FormControl>
            <Typography className="fontForError"></Typography>
        </div>

        <div
            style={{
            display: "flex",
            width: "33%",
            // flex: 1,
            minWidth: 200,
            marginTop: 10,
            paddingTop: 10,
            paddingLeft: 10,
            paddingRight: 10,
            justifyContent: "center",
            alignItems: "center",
            }}
        >
            <FormControl fullWidth>
            <LocalizationProvider dateAdapter={AdapterDateFns}>
                <DesktopDatePicker
                label="التاريخ"
                inputFormat="yyyy/MM/dd"
                value={(typeof OtherBusinessFormListForUpdate.date === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(OtherBusinessFormListForUpdate.date)) ? new Date(Number(OtherBusinessFormListForUpdate.date.slice(0,4)), Number(OtherBusinessFormListForUpdate.date.slice(5,7))-1, Number(OtherBusinessFormListForUpdate.date.slice(8,10))) : (OtherBusinessFormListForUpdate.date instanceof Date ? OtherBusinessFormListForUpdate.date : null)}
                onChange={(formDate) => {
                    const val = (formDate instanceof Date && !isNaN(formDate.getTime())) ? formDate : null;
                    setOtherBusinessFormListForUpdate({
                        ...OtherBusinessFormListForUpdate,
                        date: val,
                    })
                }}
                renderInput={(params) => <TextField {...params} />}
                />
            </LocalizationProvider>
            </FormControl>
            <Typography className="fontForError"></Typography>
        </div>
        <div
            style={{
            display: "flex",
            // width: "20%",
            flex: 1,
            minWidth: 200,
            marginTop: 10,
            paddingTop: 10,
            paddingLeft: 10,
            paddingRight: 10,
            justifyContent: "center",
            alignItems: "center",
            }}
        >
            <FormControl fullWidth>
            <TextField
                label="جهة الاصدار "
                variant="outlined"
                value={OtherBusinessFormListForUpdate.issuer}
                onChange={(e) => {
                    setOtherBusinessFormListForUpdate({
                        ...OtherBusinessFormListForUpdate,
                        issuer:e.target.value,
                    })
                }}
            />
            </FormControl>
            <Typography className="fontForError"></Typography>
        </div>
        <div
            style={{
            display: "flex",
            width: "33%",
            // flex: 1,
            minWidth: 200,
            marginTop: 10,
            paddingTop: 10,
            paddingLeft: 10,
            paddingRight: 10,
            justifyContent: "center",
            alignItems: "center",
            }}
        >
            <FormControl fullWidth>
            <TextField
                label="المبلغ"
                variant="outlined"
                type={"number"}
                value={OtherBusinessFormListForUpdate.amount}
                onChange={(e) => {
                    setOtherBusinessFormListForUpdate({
                        ...OtherBusinessFormListForUpdate,
                        amount:e.target.value,
                    })
                }}
            />
            </FormControl>
            <Typography className="fontForError"></Typography>
        </div>
        <div
            style={{
            display: "flex",
            // width: "20%",
            flex: 1,
            minWidth: 200,
            marginTop: 10,
            paddingTop: 10,
            paddingLeft: 10,
            paddingRight: 10,
            justifyContent: "center",
            alignItems: "center",
            }}
        >
            <FormControl fullWidth>
            <TextField
                label="العملة "
                variant="outlined"
                multiline
                value={OtherBusinessFormListForUpdate.currency}
                onChange={(e) => {
                    setOtherBusinessFormListForUpdate({
                        ...OtherBusinessFormListForUpdate,
                        currency:e.target.value,
                    })
                }}
            />
            </FormControl>
            <Typography className="fontForError"></Typography>
        </div>
        <div
            style={{
            display: "flex",
            // width: "20%",
            flex: 1,
            minWidth: 200,
            marginTop: 10,
            paddingTop: 10,
            paddingLeft: 10,
            paddingRight: 10,
            justifyContent: "center",
            alignItems: "center",
            }}
        >
            <FormControl fullWidth>
            <TextField
                label="الملاحظات "
                variant="outlined"
                multiline
                value={OtherBusinessFormListForUpdate.note}
                onChange={(e) => {
                    setOtherBusinessFormListForUpdate({
                        ...OtherBusinessFormListForUpdate,
                        note:e.target.value,
                    })
                }}
            />
            </FormControl>
            <Typography className="fontForError"></Typography>
        </div>
        </div>
           
      </div>
    </div>
    <div
      style={{
        display: "flex",
        marginTop: 10,
        backgroundColor: "#fefefe",
        paddingLeft: 10,
        paddingRight: 10,
        paddingBottom: 30,

        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <Button
        variant="contained"
        style={{
          backgroundColor: "#5f7b8a",
          width: "50%",
        }}
        onClick={() => sentUpdateData()}
      >
        {!loading ? (
          "تحديث"
        ) : (
          <div class="spinner-border " role="status">
            <span class="visually-hidden">Loading...</span>
          </div>
        )}
      </Button>
    </div>

    {/* snack alert box here ... */}
    <Snackbar
      open={snackBar.open}
      autoHideDuration={6000}
      onClose={handleClose}
      anchorOrigin={{ vertical, horizontal }}
    >
      <Alert
        onClose={handleClose}
        severity={snackBar.severity}
        sx={{ width: "100%" }}
      >
        {snackBar.message}
      </Alert>
    </Snackbar>
  </div>
  )
}
